import { BaseObject } from "../core/BaseObject";
import { MailingGroupEmployee } from "./mailing-group-employee";

export class MailingGroup extends BaseObject {
    mailingGroupId: number;
    name: string;

    employees: MailingGroupEmployee[] = [];
}